export const EDIT_DATASHEET = "EDIT_DATASHEET";

const editDataSheet = (payload) => ({ type: EDIT_DATASHEET, payload });

export { editDataSheet };
